import {Fragment, useEffect, useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

import {StatementInvoiceService} from '../StatementInvoiceService';
import {InvoiceService} from '../../hoa-don/InvoiceService';

import {useForm} from '../../../shared/hooks/Form';
import {ToastService} from '../../../AppToast';

import {FormatDisplay} from '../../../shared/format';
import {translateError} from '../../../shared/language';
import {useSign} from '../../../shared/component/Sign';

export const DialogStatement = ({title, display, setDisplay, selectedItem, reloadLazyData, documentType}) => {

  const [submitting, setSubmitting] = useState(false);
  const [id, setId] = useState(null);

  useEffect(() => {
    if (display && selectedItem) {
      load();
    }
  }, [display, selectedItem]); // eslint-disable-line react-hooks/exhaustive-deps

  const load = () => {
    StatementInvoiceService.getByInvoice(selectedItem.invoiceId).then(data => {
      if (data && data.id) {
        if (data.documentDate) {
          data.documentDate = new Date(data.documentDate);
        }

        if (!data.invoiceId) {
          data.invoiceId = selectedItem.invoiceId;
        }

        if (documentType != InvoiceService.documentType_Cancel) { 
          data.invoiceSerial = selectedItem.relatedInvoiceSerial;
          data.invoiceNumber = selectedItem.relatedInvoiceNumber;
          data.invoiceDate = selectedItem.relatedInvoiceDate;
        }

        if (!data.reasonAfter) {
          data.reasonAfter = `
- Căn cứ Nghị định 123/2020/NĐ-CP ngày 19/10/2020 của Chính phủ quy định về hóa đơn, chứng từ..
- Căn cứ Thông tư 78/2021/TT-BTC ngày 17/09/2021 của Bộ Tài chính hướng dẫn thực hiện Nghị định số 123/2020/NĐ-CP ngày 19 tháng 10 năm 2020 của Chính phủ quy định về hóa đơn, chứng từ.
- Căn cứ vào thỏa thuận giữa các bên.`;
        }

        data.documentType = documentType;
        setValue(data);

        if (data.id === '00000000-0000-0000-0000-000000000000') {
          setId(null);
        } else {
          setId(data.id);
        }
      }
    });
  }

  const {renderSign, sign} = useSign({onComplete: load});
  const getInvoiceId = () => {
    let invoiceId = selectedItem.invoiceId;
    if (documentType != InvoiceService.documentType_Cancel && selectedItem.relatedInvoiceId) {
      invoiceId = selectedItem.relatedInvoiceId;
    }
    return invoiceId;
  }
  const doSign = () => {
    // sign({
    //   "CommandName": "SignSS04",
    //   "Id": selectedItems['id']
    // });
  }

  const {render: renderForm, setValue, valid: formValid, getValue} = useForm({
    fields: [
      {field: 'id', type: 'hidden'},
      {field: 'documentType', type: 'hidden'},
      {field: 'invoiceId', type: 'hidden'},
      {field: 'invoiceSerial', type: 'hidden'},
      {field: 'invoiceNumber', type: 'hidden'},
      {field: 'invoiceDate', type: 'hidden'},
      {type: 'custom', className: 'md:col-12 text-center mb-0 mt-1', body: <h3 className="mb-0 uppercase">Cộng hoà xã hội chủ nghĩa Việt Nam</h3>},
      {type: 'custom', className: 'md:col-12 text-center mb-4', body: <b>Độc lập - Tự do - Hạnh phúc</b>},
      {type: 'custom', className: 'md:col-12 text-center mb-0', body: <h3 className="mb-0 uppercase">Biên bản {title} hoá đơn</h3>},
      {field: 'documentNo', header: 'Số biên bản', InputTextProps: {maxLength: 400}, className: 'md:col-12', labelClassName: 'md:col-5 justify-content-end', inputClassName: 'md:col-3'},
      {field: 'reasonAfter', header: '', type: 'InputTextarea', className: 'md:col-12', inputClassName: 'font-italic'},
      {field: 'documentDate', header: 'Hôm nay, ngày', type: 'Calendar', className: 'md:col-4', labelClassName: 'md:col-5', inputClassName: 'md:col-7'},
      {
        type: 'custom', className: 'md:col-6 pt-2', body: <p>Chúng tôi gồm có:</p>
      },
      {field: 'sellerLegalName', header: 'Bên A (Bên bán)', type: 'text', className: 'md:col-12', labelClassName: 'md:col-2 font-bold', inputClassName: 'md:col-10 font-bold h-35 lh-35'},
      {field: 'sellerAddress', header: 'Địa chỉ', type: 'text', className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10 h-35 lh-35'},
      {field: 'sellerTaxCode', header: 'Mã số thuế', type: 'text', className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8 h-35 lh-35'},
      {field: 'sellerTel', header: 'Số điện thoại', className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {field: 'sellerPersonContact', header: 'Đại diện', className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {field: 'sellerPosition', header: 'Chức vụ', className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {field: 'buyerLegalName', header: 'Bên B (Bên mua)', className: 'md:col-12', labelClassName: 'md:col-2 font-bold', inputClassName: 'md:col-10 font-bold'},
      {field: 'buyerAddress', header: 'Địa chỉ', className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10'},
      {field: 'buyerTaxCode', header: 'Mã số thuế', className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {field: 'buyerTel', header: 'Số điện thoại', className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {field: 'buyerPersonContact', header: 'Đại diện', className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {field: 'buyerPosition', header: 'Chức vụ', className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {
        type: 'template', className: 'md:col-12', template: (item) => {
          let {invoiceSerial, invoiceNumber, invoiceDate, documentType} = item;
          let form, serial;
          if (invoiceSerial) {
            form = invoiceSerial.substring(0, 1);
            serial = invoiceSerial.substring(1, invoiceSerial.length);
          }
          if (invoiceDate) {
            invoiceDate = FormatDisplay.date(invoiceDate);
          }

          if(documentType === InvoiceService.documentType_Cancel) {
            return <i>Hai bên thống nhất lập biên bản này để thu hồi và huỷ hoá đơn  có mẫu số {form}, ký hiệu {serial}, số {invoiceNumber}, ngày {invoiceDate} theo quy định.</i>
          }

          if(documentType === InvoiceService.documentType_Substitute) {
            return <i>Hai bên thống nhất lập biên bản này để thay thế cho hóa đơn có mẫu số {form}, ký hiệu {serial}, số {invoiceNumber}, ngày {invoiceDate} theo quy định.</i>
          }
          if(documentType === InvoiceService.documentType_Adjust) {
            return <i>Hai bên thống nhất lập biên bản này để điều chỉnh cho hóa đơn có mẫu số {form}, ký hiệu {serial}, số {invoiceNumber}, ngày {invoiceDate} theo quy định.</i>
          }
        }
      },
      {field: 'reason', header: `Lý do ${title}`, className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10'},
      {
        type: 'custom', className: 'md:col-12', body: <p>Chúng tôi xin cam đoan các thông tin khai ở trên là hoàn toàn chính xác. Nếu có bất kỳ sai sót nào chúng tôi xin chịu trách nhiệm trước pháp luật.</p>
      },
      {
        type: 'custom', className: 'md:col-6 mt-3', body: (
          <div className="grid">
            <div className="col-12 text-center">
              <b className="uppercase">Đại diện bên A</b>
            </div>
            <div className="col-12 text-center">
              <i>(Chữ ký số, chữ ký điện tử)</i>
            </div>
            {/* <div className="col-12 mt-3 text-center un-fluid">
              <Button label="Ký điện tử" icon="pi pi-user-edit" className="p-button-outlined p-button-sm" onClick={doSign}/>
            </div> */}
          </div>
        )
      },
      {
        type: 'custom', className: 'md:col-6 mt-3', body: (
          <div className="grid">
            <div className="col-12 text-center">
              <b className="uppercase">Đại diện bên B</b>
            </div>
            <div className="col-12 text-center">
              <i>(Chữ ký số, chữ ký điện tử)</i>
            </div>
          </div>
        )
      }
    ],
    layout: 'Horizontal',
    formClassName: 'paper'
  });

  const print = () => {
    window.open(StatementInvoiceService.getPdfUrl(id), '_blank');
  }

  const submit = () => {
    if (!submitting && formValid()) {
      setSubmitting(true);

      const data = getValue();
      let method;
      if (data.id === '00000000-0000-0000-0000-000000000000') {
        delete data.id;
        method = StatementInvoiceService.create(data);
      } else {
        method = StatementInvoiceService.update(data.id, data);
      }
      method.then(() => {
        ToastService.success();
        setDisplay(false);
        reloadLazyData();
      }).catch(({response}) => {
        ToastService.error(translateError(response));
      }).finally(() => {
        setSubmitting(false);
      });
    }
  }

  return (
    <Fragment>
      <Dialog header="Lập biên bản" visible={display} style={{width: '890px'}} position="top" onHide={() => setDisplay(false)}>

        {renderForm()}

        <div className="flex justify-content-end mt-2">
          <Button label="Lưu" icon="pi pi-check" className="p-button-sm mr-2" onClick={submit} loading={submitting}/>
          {id &&
						<Button label="In" icon="pi pi-print" className="p-button-outlined p-button-sm mr-2" onClick={print}/>
          }
          <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-outlined p-button-secondary p-button-sm"/>
        </div>
      </Dialog>
      {renderSign()}
    </Fragment>
  );
}